module.exports = __webpack_public_path__ + "assets/icons/calendar-blank-8b4d.svg";